module.exports = __webpack_public_path__ + "img/van01.87c01257.png";